import { render, staticRenderFns } from "./Cfsis.vue?vue&type=template&id=12ed2b04&"
import script from "./Cfsis.vue?vue&type=script&lang=js&"
export * from "./Cfsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports